export default {
      id: "ic_author_filter-usage",
      viewBox: "0 0 27 18",
      url: "/" + "images/icons.3.109.2.svg#ic_author_filter-usage",
      toString: function () {
        return this.url;
      }
    }